
let language = {
    HINT_MODAL_HINT_TITLE: "Hint",

    HINT_MODAL_DUPLICATE_FILE_NAME_TIP: "Duplicate file name, the file name was renamed to: ",

    HINT_MODAL_OK_BTN: "Ok",
};

export { language }